import styled from '@emotion/styled';
import * as React from 'react';
import { __ } from '../../../helpers/TranslationService';

const StyledDiv = styled.div`
    &:before {
        margin-top: 15px;
    }
`;

export class FooterUSP extends React.Component<{}, {}> {
    render() {
        return (
            <div className="row footer_userBenefits">
                <ul className="container list-inline">
                    <li className="col-xs-12 col-sm-4 text-center">
                        <StyledDiv className="icon-dreamlinesPackage-expert white-rounded" />
                        <strong>{__('Expert', 'dreamlines')}</strong>
                        <p className="hidden-xs">{__('Expert description', 'dreamlines')}</p>
                    </li>
                    <li className="col-xs-12 col-sm-4 text-center">
                        <StyledDiv className="icon-shipv2 white-rounded" />
                        <strong>{__('Board Credits Header', 'dreamlines')}</strong>
                        <p className="hidden-xs">
                            {`${__('Now up to', 'dreamlines')}`}&nbsp;
                            {`${__('200 €', 'dreamlines')}`}&nbsp;
                            {`${__('Board Credits', 'dreamlines')}`}
                        </p>
                    </li>
                    <li className="col-xs-12 col-sm-4 text-center">
                        <StyledDiv className="icon-winner white-rounded" />
                        <strong>{__('Best price Guarantee', 'dreamlines')}</strong>
                        <p className="hidden-xs">
                            {__('Best price Guarantee description', 'dreamlines')}
                        </p>
                    </li>
                </ul>
            </div>
        );
    }
}
